import React from "react";
import styled from "styled-components";
import Bg from "images/png/pitch-easy-img/start-pitch-wide.png";
import MobileBg from "images/png/pitch-easy-img/start-pitch-mobile.png";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";
import PrimaryButton from "components/buttons/primary-button";

const GetStarted = () => {
  return (
    <Container>
      <Body>
        <IconContainer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 48 49"
            fill="none"
          >
            <rect y="0.282227" width="48" height="48" rx="24" fill="#131313" />
            <path
              d="M15 33.2217L31.2876 33.2217"
              stroke="#FEA101"
              stroke-width="2.33086"
              stroke-linecap="round"
            />
            <path
              d="M15.9063 26.8148L21.274 22.5616L23.9069 25.8024L29.2746 21.5493L32.6018 18.7359M32.6018 18.7359L31.9835 24.0049M32.6018 18.7359L27.2578 18.471"
              stroke="#FEA101"
              stroke-width="3.49629"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </IconContainer>
        <Typography weight="bold" m_size="3rem" size="4rem" m_mb="0" mb="2.6">
          Get Started with Pitch Easy Today!
        </Typography>
        <TickItem>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M4.16699 11.1152L7.50033 14.4486L15.8337 6.11523"
              stroke="#FEB73D"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <Typography size="m" color={Colors.white100}>
            Make pitching your music effortless.
          </Typography>
        </TickItem>
        <TickItem>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M4.16699 11.1152L7.50033 14.4486L15.8337 6.11523"
              stroke="#FEB73D"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <Typography size="m" color={Colors.white100}>
            Build a stunning EPK in minutes.
          </Typography>
        </TickItem>
        <TickItem>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M4.16699 11.1152L7.50033 14.4486L15.8337 6.11523"
              stroke="#FEB73D"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <Typography size="m" color={Colors.white100}>
            Reach industry professionals and boost your career.
          </Typography>
        </TickItem>
        <PriceDiv>
          <Typography weight="medium" size="lg" m_size="s" mb="0.2" m_mb="0.1">
            All for just
          </Typography>
          <Typography weight="semibold" size="2xl" m_size="lg" ml="0.5">
            $99.99
          </Typography>
        </PriceDiv>
        <PrimaryButton
          onClick={() => {
            // navigate("/overview/promo-cards/create");
          }}
          text="Start Pitching Now"
          icon={<Arrow />}
          inset
          sparkle
          iconPosition="right"
          fitContent
          iconSize="2"
        />
      </Body>
    </Container>
  );
};

export default GetStarted;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10rem;
`;

const Body = styled.div`
  background: url(${Bg}), linear-gradient(170deg, #7310ec 38.89%, #a719c4 94.2%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 45rem;
  width: 100%;
  border-radius: 2rem;
  padding: 2.5rem;
  padding-left: 24rem;
  padding-right: 40rem;
  @media only screen and (max-width: 769px) {
    padding: 1.5rem 2rem;
    background: url(${MobileBg}),
      linear-gradient(170deg, #7310ec 38.89%, #a719c4 94.2%);
    height: 25rem;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const IconContainer = styled.div`
  width: 4.8rem;
  @media only screen and (max-width: 769px) {
    width: 3.2rem;
  }
`;
const TickItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 1rem;

  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const PriceDiv = styled.div`
  display: inline-flex;
  align-items: end;
  margin: 1.6rem 0;
  @media only screen and (max-width: 769px) {
    margin: 0.8rem 0;
  }
`;
